import axios from "axios";

const optionVal = {
    data() {
        return {
            enabledOptions: new Map([["1", "启用"], ["0", "停用"]]),
            typeOptions: new Map([
                ["menu", "菜单"],
                ["button", "按钮"],
                ["interface", "接口"],
                ["panle", "门户模块"],
                ["group", "分组/文件夹"],
            ]),
            idenCardTypeOptions: new Map(),         //身份证件类型 1001
            userTypeOptions: new Map(),             // 人员类型/角色类型 1002
            campusOptions: new Map(),               //所属校区 1003
            triggerTypeOptions: new Map(),          //触发类型 1004
            devTypeOptions: new Map(),              //设备类型 1005
            devFactoryOptions: new Map(),           //设备厂家 1006
            collegeOptions: new Map(),              //学院 1007
            carBreakTypeOptions: new Map(),         //违章类型 1008
            protectLevelOptions: new Map(),         //防护等级 1009
            userBlacklistOptions: new Map(),        //黑名单类型 1010
            carBlacklistOptions: new Map(),         //车辆黑名单类型 1011
            alarmTypeOptions: new Map(),            //告警类型 1012
            noticeTypeOptions: new Map(),           //公告类型 1013
            incidentTypeOptions: new Map(),         //事件类型 1019
            detailTypeOptions: new Map(),           //告警小类类型 1018
            gradeOptions: new Map(),                //所属班级 1020
            majorOptions: new Map(),                //所属专业 1021

        };
    },
    methods: {
        initOptions() {
            axios({
                url: "/user/sysParameter",
                method: "get",
                headers: {
                    'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
                }
            }).then(res => {
                //获取数据源的方式可以修改，暂时从后端接口请求
                let options = new Map();
                let data = res.data.data;
                Object.keys(data).forEach(key => {
                    let m = data[key];
                    let map = new Map();
                    Object.keys(m).forEach(k => {
                        map.set(k, m[k]);
                    });
                    options.set(key, map);
                });
                this.idenCardTypeOptions = options.get("1001");
                this.userTypeOptions = options.get("1002");
                this.campusOptions = options.get("1003");
                this.triggerTypeOptions = options.get("1004");
                this.devTypeOptions = options.get("1005");
                this.devFactoryOptions = options.get("1006");
                this.collegeOptions = options.get("1007");
                this.carBreakTypeOptions = options.get("1008");
                this.protectLevelOptions = options.get("1009");
                this.userBlacklistOptions = options.get("1010");
                this.carBlacklistOptions = options.get("1011");
                this.alarmTypeOptions = options.get("1012");
                this.noticeTypeOptions = options.get("1013");
                this.incidentTypeOptions = options.get("1019")
                this.detailTypeOptions = options.get("1018");
                this.gradeOptions = options.get("1020");
                this.majorOptions = options.get("1021");
            }).catch(() => {
            });
        }
    },
    mounted() {
        this.initOptions();
    }

}

export default optionVal;